export default "__VITE_ASSET__d7d994fc__"